import { render } from "./carView.vue?vue&type=template&id=58833264&scoped=true"
import script from "./carView.vue?vue&type=script&lang=js"
export * from "./carView.vue?vue&type=script&lang=js"

import "./carView.vue?vue&type=style&index=0&id=58833264&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58833264"]])

export default __exports__